import { render, staticRenderFns } from "./ProductClassCard.vue?vue&type=template&id=28590dac&scoped=true&"
import script from "./ProductClassCard.vue?vue&type=script&lang=ts&"
export * from "./ProductClassCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28590dac",
  null
  
)

export default component.exports